import { Component } from "@angular/core";

@Component({
  selector: "oz-stepper-toolbar",
  template: "<ng-content></ng-content>",
})
export class ToolbarComponent {}
